import { useState, useEffect } from "react";

const NAV_ITEMS = [
  {
    label: "News",
    name: "news",
    comment:
      "Appears just below 'welcome' text near top of site. If checked, ensure you have news or will show 'No current news.'",
  },
  {
    label: "Events",
    name: "events",
    comment:
      "Recommended. Populate your events for the season and section will remain populated with next x events.",
  },
  {
    label: "Where we meet",
    name: "whereWeMeet",
    comment: "",
  },
  {
    label: "About",
    name: "about",
    comment: "Recommended. Anchors to top of 'About' section.",
  },
  {
    label: "Tickets",
    name: "ticket",
    comment: "",
  },
  {
    label: "Membership",
    name: "membership",
    comment:
      "Recommended. Can show an invitation to join you at the next event or a full member registration form.",
  },
  {
    label: "Leadership",
    name: "leadership",
    comment: "",
  },
  {
    label: "Community",
    name: "community",
    comment: "",
  },
  {
    label: "Store",
    name: "store",
    comment:
      "Recommended if you will have merchandise in your store throughout the season.",
  },
  {
    label: "Gallery",
    name: "gallery",
    comment: "",
  },
];

const DEFAULT_NAV = {
  home: false,
  news: false,
  events: false,
  whereWeMeet: false,
  about: false,
  mission: false,
  codeOfConduct: false,
  membership: false,
  leadership: false,
  contact: false,
  community: false,
  gallery: false,
  ticket: false,
};

const NavigationSetup = ({ adminData, updated, save, isUpdated, onSave }) => {
  const [navState, setNavState] = useState(DEFAULT_NAV);

  // getDerivedStateFromProps equivalent: sync from props when `updated` is true
  useEffect(() => {
    if (updated) {
      const websiteConfig = adminData?.data?.websiteConfig;
      if (websiteConfig?.navigation) {
        setNavState(websiteConfig.navigation);
      } else {
        setNavState(DEFAULT_NAV);
      }
    }
  }, [updated, adminData]); // eslint-disable-line react-hooks/exhaustive-deps

  // componentDidUpdate equivalent: fire onSave when save triggers
  useEffect(() => {
    if (save && !isUpdated) {
      onSave({ navigation: { ...navState } });
    }
  }, [save, isUpdated]); // eslint-disable-line react-hooks/exhaustive-deps

  const handleChange = (e) => {
    const count = Object.values(navState).filter(Boolean).length;
    if (count < 8 || !e.target.checked) {
      setNavState((prev) => ({ ...prev, [e.target.name]: e.target.checked }));
    } else {
      alert("Can't select more than 8!");
    }
  };

  return (
    <div className="mt-5" style={{ width: "100%", padding: "0px 15px" }}>
      <div className="row">
        <span style={{ fontSize: "20", fontWeight: "bold", marginBottom: 0 }}>
          Navigation
        </span>
      </div>
      <div className="row">
        <p style={{ fontSize: 15 }}>
          Select up to 8 navigation items. Sections do not need navigation in
          header for content to appear in the site. For example, showing
          'About' in navigation will anchor to the beginning of that section
          where visitor can then scroll to see Mission, Membership and
          Leadership content.
        </p>
      </div>
      {NAV_ITEMS.map(({ label, name, comment }) => {
        if (window.innerWidth <= 600) {
          return (
            <div
              key={name}
              style={{ margin: "0 auto", width: "100%", maxWidth: "90%" }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  marginBottom: "1rem",
                }}
              >
                <div style={{ display: "flex", alignItems: "center" }}>
                  <span style={{ fontSize: "17px", flexGrow: 1 }}>{label}</span>
                  <input
                    type="checkbox"
                    name={name}
                    checked={navState[name] || false}
                    style={{ height: "20px", width: "20px", borderRadius: "5px" }}
                    onChange={handleChange}
                  />
                </div>
                <div>
                  <span style={{ fontSize: "14px", color: "#676767" }}>
                    {comment}
                  </span>
                </div>
              </div>
            </div>
          );
        }
        return (
          <div key={name} style={{ margin: "0 auto", width: "90%" }}>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                marginBottom: "1rem",
              }}
            >
              <div
                style={{
                  width: "20%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  gap: "6px",
                }}
              >
                <span style={{ fontSize: "17px" }}>{label}</span>
                <input
                  type="checkbox"
                  name={name}
                  checked={navState[name] || false}
                  style={{ height: "20px", width: "20px", borderRadius: "5px" }}
                  onChange={handleChange}
                />
              </div>
              <div style={{ marginLeft: "2rem" }}>
                <span style={{ fontSize: "14px", color: "#676767" }}>
                  {comment}
                </span>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default NavigationSetup;
